/**
 * Whether the activity-map home shows the goal picker ("What's your goal?") in place of the home.
 * The one rule on all three surfaces — iOS `ActivityMapScreen.showsGoalPicker`, Android
 * `activityMapShowsGoalPicker`: the picker is the home of a user who has NOT finished onboarding, and
 * only once we know that. An unknown answer (the recipient read still out, or failed) is not "unfinished",
 * so it shows the home: a finished user must never get the picker because a read was slow.
 *
 * No runtime imports, so the unit test does not load the app's dependency graph (see the package CLAUDE.md).
 */
export function homeShowsGoalPicker(input: { known: boolean; finished: boolean }): boolean {
  return input.known && !input.finished;
}
